import React from 'react';
import ReactDOM from 'react-dom';

import ImgIconComp from '../../imgcomp';
import { withTranslation } from 'react-i18next';

// Delete Non Takeaway
class DeleteTakeawayPopup extends React.Component {
  constructor(props) {
    super(props);
    this.closeWsPopup = this.closeWsPopup.bind(this);
    this.deleteNonTakeAway = this.deleteNonTakeAway.bind(this);
  }

  closeWsPopup() {
    if (document.getElementById('delete-meeting-confirm-box')) {
      ReactDOM.unmountComponentAtNode(document.getElementById('delete-meeting-confirm-box'));
    }
    $(delete_meeting_confirm).dialog('close');
  }

  deleteNonTakeAway(e, id, meetingId, type, topicId) {
    const { isFUSEnabled, files } = this.props;
    this.props.deleteTopicTakeNonTake(id, meetingId, type, topicId, isFUSEnabled, files);
    this.closeWsPopup();
  }

  render() {
    const { t } = this.props;
    const Type = this.props.type;
    let TypeOf = 'takeaway';
    if (Type == 'topic') {
      TypeOf = Type;
    }
    return (
      <div className="wbmodal" id="delete-meeting-confirm-box">
        <div className="wbmodal-header">
          <div className="wbmodal-htitle left">
            <b>
              {`${t('Delete')} ${TypeOf}`}
            </b>
          </div>
          <div className="wbmodal-hcancel closeWsPopup right clickable" onClick={this.closeWsPopup}>
            <ImgIconComp id="close" />
          </div>
          <div className="clear" />
        </div>
        <div className="wbmodal-content" style={{ padding: '20px 30px' }}>
          <div>
            <span>
              {` ${t('Are you sure you want to delete this')} ${TypeOf}?`}
            </span>
          </div>
          <div className="gbl-butn-wraper" style={{ float: 'right', width: '56px', padding: '10px 0 0 0' }}>
            <div className="gbl-btn" data-id={this.props.meetingId} onClick={event => this.deleteNonTakeAway(event, this.props.id, this.props.meetingId, this.props.type, this.props.topicId)} style={{ padding: '5px 14px' }}>Yes</div>
          </div>
        </div>
      </div>
    );
  }
}
export default withTranslation()(DeleteTakeawayPopup);
